/**
 *
 * @param state
 * @param action
 *      type string any. previous state. for the first time, must be null
 *      payload array data. containing object
 */
export default function(state = {}, action){
    console.log('action', action);
    switch(action.type){
        case 'TITLE':
            //'...' keeps current properties that object has
            return {...state, getTitle : action.payload.data}
            //return action.payload.data;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/title.js